const tryParseJsonObject = <T>(json: string): T => {
    try {
        return JSON.parse(json);
    }
    catch (error) {
        return {} as T;
    }
}

export { tryParseJsonObject }